
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.835 14.518c.22.22.22.578 0 .798l-4.519 4.519a.565.565 0 01-.798 0l-4.519-4.519a.565.565 0 11.799-.798l4.119 4.119 4.119-4.12c.22-.22.578-.22.799 0zM6.811 10.61a.565.565 0 010-.799l4.518-4.518c.22-.22.579-.22.8 0l4.517 4.518a.565.565 0 01-.798.799l-4.12-4.12-4.118 4.12a.565.565 0 01-.799 0z","fill":"currentColor"}})])
          )
        }
      }
    